<script lang="ts" setup type="text/x-template" id="editorTemplate">
import AUApi from "@/api";
import { ref, onMounted, reactive } from "vue";
import { getKennungValueDisplay, getKennungValue, getKennungTitle } from "@/DataHelper";
import { checkBegriff, globalsKennung } from "@/local";
import CommonBaseButtons from "@/components/common/BaseButtons.vue";
import { mountedBase, onSave, BaseSetup } from "@/DataLoaderStatic";
import { goBack } from "@/NavigationHelper";

import {
  createEditorValidator,
  provideEditorValidator,
} from "@/components/EditorValidator";
import { showSnackbar } from "@/UIHelper";
import { Globals } from "@/Globals";
const validator = createEditorValidator();
provideEditorValidator(validator);

const emit = defineEmits(["back", "save", "delete"]);
let IsAllDay = ref<boolean>(false);
let color: any = "success";
let stellVertreter: boolean = false;
let disabled = ref<boolean>(false);
let stellBew: any = false;
let date: any = "";
let bewilligung: boolean = false;
let stellOffen: boolean = false;
let maName = ref<string>("");
let zeitart = ref<string>("");
let maNameTitel: string = "";
let zeitartTitel: string = "";
let saveVisible = ref<boolean>(false);
let setKey = ref<number>(0);

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_Planung_Dialog_Stellvertreter",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  await mountedBase(uiData, pageParams);
  if (uiData.data.length === undefined) {
    // gibt es keine Daten - dann soll kein Dialog geöffnet werden!
    // $emit("closeDialog");
  } else {
    if (!uiData.showLoading && uiData.data) {
      maNameTitel = getKennungTitle("MA", uiData.columns);
      zeitartTitel = getKennungTitle("ZA", uiData.columns);
      maName.value = getKennungValueDisplay(uiData.data[0], "MA", uiData.columns);
      const abwText = getKennungValue(uiData.data[0], "abwText", uiData.columns);
      if (abwText) {
        const showText = getKennungTitle("abwText", uiData.columns);
        zeitart.value = showText;
      } else {
        zeitart.value = getKennungValueDisplay(uiData.data[0], "ZA", uiData.columns);
      }
      const allDay = getKennungValueDisplay(
        uiData.data[0],
        "B_CALC_FIELD",
        uiData.columns
      );
      if (allDay === true) {
        IsAllDay.value = true;
      }
      const zuBewilligen = getKennungValueDisplay(
        uiData.data[0],
        "GRANTED",
        uiData.columns
      );
      if (zuBewilligen === "ja") {
        bewilligung = true;
      }
      const checkBewilligt = getKennungValueDisplay(uiData.data[0], "b1", uiData.columns);

      const checkStellvertreter = getKennungValueDisplay(
        uiData.data[0],
        "SV",
        uiData.columns
      );

      if (checkStellvertreter) {
        stellVertreter = true;
        const bewStell = getKennungValueDisplay(uiData.data[0], "b2", uiData.columns);
        if (bewStell === "bewilligt") {
          stellBew = true;
        } else if (checkBewilligt === "offen") {
          stellOffen = true;
        }
      }
      // braucht man das nicht mehr?
      // const self = checkBegriff("Web_VG_Selfservice");
      // if (!self) {
      //   const maAIC = getKennungValue(uiData.data[0], "MA", uiData.columns);
      //   const userAIC = AUApi.Current.user.aic;
      //   if (maAIC === userAIC) {
      //     // disabled = true;
      //   }
      // }
    }
    uiData.showLoading = false;
    uiData.initialized = true;
  }
});

function checkChanged(val: any) {
  saveVisible.value = true;
  setKey.value += +1;
}
function showDelete() {
  return uiData.data && uiData.data[0].aic_Bew_pool && uiData.data[0].aic_Bew_pool > 0;
}

function onDelete() {
  if (uiData.data && uiData.data[0].aic_Bew_pool) {
    emit("delete", uiData.data[0].aic_Bew_pool);
  }
}
async function onValidate() {
  return await validator.validateAsync();
}
async function save() {
  const isvalid = await onValidate();
  if (!isvalid.valid) {
    showSnackbar({
      text:
        "Validierung fehlgeschlagen - Bitte prüfen! (" +
        isvalid.invalidFields.join(", ") +
        ")",
      duration: 4000,
      color: "error",
    });
    return;
  }
  const aicAbfAllBez = globalsKennung(Globals.Begriff, "WebPlanungSpeichern");
  // es muss unbedingt die 2te Abfrage mitgegeben werden sonst stimmen die Daten in der Bew Planung nicht!
  onSave(uiData, pageParams, aicAbfAllBez.aic, "", undefined, pageParams.aic)?.then(
    () => {
      emit("save");
    }
  );
}
</script>
<template id="editorTemplate">
  <v-card v-if="!uiData.showLoading" class="dvhDialog" :loading="uiData.showLoading">
    <v-toolbar class="subtitle-1 dvhBackground lighten-2 pl-2" style="color: white">
      <span style="color: white">
        {{ maName }}:
        {{ zeitart }}
      </span>
      <v-spacer></v-spacer>
      <v-divider class="px-2" vertical></v-divider>
      <v-btn @click="goBack()" icon="mdi-close"> </v-btn>
    </v-toolbar>
    <v-card-text>
      <EditTextArea id="Description" kennung="MEMO" name="Bemerkung" />

      <EditCheckBox3 :disabled="disabled" @change="checkChanged" kennung="b2" />

      <EditTextArea id="VG" kennung="VG" @change="checkChanged" name="Bemerkung" />
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <CommonBaseButtons
        :key="setKey"
        :createVisible="false"
        :refreshVisible="false"
        :deleteVisible="false"
        :backVisible="false"
        @back="goBack()"
        @delete="onDelete"
        :saveVisible="saveVisible"
        @save="save"
      ></CommonBaseButtons>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.fullcol {
  width: 100%;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  margin: 0px;
}
.dvhDialog {
  /* NOTCH bei Iphone umgehen */
  padding-top: 20px;
  padding-bottom: 20px;
  padding-top: constant(safe-area-inset-top);
  /* Status bar height on iOS 11+ */
  padding-top: env(safe-area-inset-top);
  padding-bottom: constant(safe-area-inset-bottom);
  /* Status bar height on iOS 11+ */
  padding-bottom: env(safe-area-inset-bottom);
  padding: 0px;
  width: "400px";
}
@media (max-width: 550px) {
  .dvhDialog {
    padding: 0px;
    width: 300px;
  }
}
</style>

function onValidate() { throw new Error("Function not implemented."); } function
onValidate() { throw new Error("Function not implemented."); }
